<template>
    <v-container class="py-10" fluid>
      <div class="policy-container mx-auto">
        <h1 class="policy-title mb-6">Privacy Policy</h1>
  
        <section class="mb-6">
          <h2 class="section-title mb-2">Personal Data We Collect</h2>
          <v-divider class="my-3" color="white"></v-divider>
          <ul class="section-list">
            <li><strong>Personal profile:</strong> We collect your first and last name, email address, phone number, and other similar contact data.</li>
            <li><strong>Credentials:</strong> We collect passwords and security information used for authentication and account access.</li>
            <li><strong>Usage data:</strong> We collect data about how you and your device interact with our services. This includes data about your device and the network you use to connect to our services, including IP address, device identifiers, information about the operating systems.</li>
            <li><strong>Content:</strong> We collect content of your files and communications when necessary to provide you with the services you use. For example, if you receive a message using a UniXcape hosted messaging service, we need to collect the content of that message in order to deliver it to your softphone client, display it to you, enable you to reply to it, and store it for you until you choose to delete it. Examples of this data include the content of instant messages, or documents, photos, music or videos you file transfer using UniXcape services..</li>
          </ul>
        </section>
  
        <section class="mb-6">
          <h2 class="section-title mb-2">How We Use Personal Data</h2>
          <v-divider class="my-3" color="white"></v-divider>
          <ul class="section-list">
            <li><strong>Contact list:</strong> UniXcape Communicator use your contacts’ phone numbers from your phone’s address book for make call.</li>
            <li><strong>Photos and other files:</strong> We only access to the files stored on your phone when you send it in text messages with UniXcape Communicator.</li>
            <li><strong>Audio, video, and text messages:</strong> We access and temporary store audio and video packets when you make UniXcape Communicator calls, but we never read or listen your private voice, video, or text content.</li>
            <li><strong>Email address:</strong> For activate your account, reset your password.</li>
            <li><strong>Push notifications:</strong> To let you know of incoming calls, chats and other messages, our apps use the notification service on your device.</li>
          </ul>
        </section>
  
        <section class="mb-6">
          <h2 class="section-title mb-2">Security</h2>
          <v-divider class="my-3" color="white"></v-divider>
          <p class="section-text">
            Personal information we collect is stored in password-controlled servers with limited access.
          </p>
        </section>
  
        <section>
          <h2 class="section-title mb-2">Questions / Concerns</h2>
          <v-divider class="my-3" color="white"></v-divider>
          <p class="section-text">
            If there are any questions regarding this privacy policy, you may contact us at
            <a href="mailto:service.th@tgs-enterprise.com" class="contact-link">
              service.th@tgs-enterprise.com
            </a>.
          </p>
        </section>
      </div>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "PolicyView",
  };
  </script>
  
  <style scoped>
  .policy-container {
  max-width: 800px;
  margin: auto;
  color: white; /* ตัวหนังสือสีขาว */
  background: transparent; /* ไม่มีพื้นหลัง */
}

.policy-title {
  font-weight: bold; /* ตัวหนา */
  font-size: 3rem; 
}

.section-title {
  font-weight: bold; /* ตัวหนา */
  font-size: 1.5rem; 
}

.section-text {
  font-size: inherit; /* ขนาดปกติ */
  line-height: 1.6;
}

.section-list {
  list-style-type: disc;
  padding-left: 1.5rem;
  font-size: inherit; /* ขนาดปกติ */
  line-height: 1.6;
}

.contact-link {
  color: #fff;
  text-decoration: underline;
}

a.contact-link:hover {
  color: #ddd;
}
</style>
  